import LoadPanel from 'app/components/LoadPanel';
import { NotFoundPage } from 'app/components/NotFoundPage';
import { WrapContent } from 'app/components/WrapContent';
import useAxios from 'axios-hooks';
import useDictionary from 'hooks/useDictionary';
import React, { createContext, useContext, useEffect, useState } from 'react';
import { notification } from 'utils/notification';
import './styles.scss';

const List = React.lazy(() => import('./List'));
const CreateEditView = React.lazy(() => import('./CreateEditView'));

/**
 * create context
 */
const ModuleContext = createContext({});
ModuleContext.displayName = 'ServiceManagerPage_Context';
export const useModuleContext = () => {
  return useContext(ModuleContext);
};

const ServiceManagerPage = () => {
  const { t }: any = useDictionary({ programId: 'service' });
  const [data, setData] = useState([]);
  const [modeView, setModeView] = useState({
    type: 'list',
    data: null,
  });

  const [{ loading }, refetchData] = useAxios(
    {},
    { manual: true, autoCancel: true, useCache: false },
  );

  useEffect(() => {
    onSubmit();
  }, []);

  /**
   * on submit
   *
   */
  const onSubmit = async () => {
    const res = await refetchData({
      url: '/service/list',
      method: 'GET',
    });
    if (res?.data?.status === '200') {
      setData(res?.data?.data || []);
    } else {
      notification({ res });
    }
  };

  const value: any = {
    t,
    data,
    setData,
    modeView,
    setModeView,
    onSubmit,
  };

  /**
   * render content
   *
   * @return {*}
   */
  const renderContent = () => {
    switch (modeView?.type) {
      case 'list':
        return <List />;
      case 'create':
      case 'edit':
        return <CreateEditView />;
      default:
        return <NotFoundPage />;
    }
  };

  return (
    <WrapContent>
      <ModuleContext.Provider value={value}>
        <React.Suspense fallback={<LoadPanel visible={true} />}>
          <LoadPanel visible={loading} />
          {renderContent()}
        </React.Suspense>
      </ModuleContext.Provider>
    </WrapContent>
  );
};

export default ServiceManagerPage;
